"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSigningMethodPassedError = exports.NoSigningMethodPassed = void 0;
const NO_SIGNING_METHOD_ERROR_MSG = `
  SDK Error: No signing method passed.
  Account or near/wallet-selector Wallet is required to sign transactions
`;
class NoSigningMethodPassed extends Error {
}
exports.NoSigningMethodPassed = NoSigningMethodPassed;
exports.NoSigningMethodPassedError = new NoSigningMethodPassed(NO_SIGNING_METHOD_ERROR_MSG);
//# sourceMappingURL=errors.js.map